export default {"src":"/_next/static/media/CloseButton.0ad476f7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};